import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetOnboardingProgressResponse = {
	isSalesforceConnected: boolean;
	isSalesforceSynced: boolean;
	missingSalesforceSyncPermission?: boolean;
	organizationId?: number;
	latestSuccessfulSfdcImportId: number;
	currentlyRunningSfdcImportId: number;
};

export const getOnboardingProgress = createGetEndpoint<void, GetOnboardingProgressResponse>(
	'/api/v3/core/onboarding/progress'
);
